module.exports = __webpack_public_path__ + "static/media/vlogo.117d33ee.png";